import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { useTranslation } from 'react-i18next';
import {
  isAnalyticsConfigured,
  OPEN_CONSENT_BANNER_EVENT,
} from '../../lib/analyticsConsent';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const analyticsConfigured = isAnalyticsConfigured();

  const handleManageConsent = () => {
    window.dispatchEvent(new Event(OPEN_CONSENT_BANNER_EVENT));
  };

  return (
    <footer className="footer">
      <div className="footer__content">
        <p className="footer__text">{t('copyright', { year: currentYear })}</p>
        <nav
          className="footer__nav"
          aria-label={t('nav.footerNavigation', 'Footer navigation')}
        >
          <Link to="/privacy-policy" className="footer__link">
            {t('nav.privacyPolicy', 'Polityka Prywatnosci')}
          </Link>
          <span className="footer__separator">|</span>
          <Link to="/terms-of-service" className="footer__link">
            {t('nav.terms', 'Regulamin')}
          </Link>
          <span className="footer__separator">|</span>
          <Link to="/about" className="footer__link">
            {t('nav.about', 'O projekcie')}
          </Link>
          {analyticsConfigured && (
            <>
              <span className="footer__separator">|</span>
              <button
                onClick={handleManageConsent}
                className="footer__link footer__link--button"
                title={t('nav.manageConsent', 'Zarzadzaj zgodami')}
              >
                {t('nav.manageConsent', 'Zarzadzaj zgodami')}
              </button>
            </>
          )}
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
